import { useEffect, useRef } from "react";
import { useAuth } from "../contexts/AuthContext";
import { useToast } from "../contexts/ToastContext";

export function useSessionTimeout(warningMinutes = 55) {
  const { currentUser } = useAuth();
  const toast = useToast();
  const warningShown = useRef(false);

  useEffect(() => {
    if (!currentUser) {
      warningShown.current = false;
      return;
    }

    const checkInterval = setInterval(() => {
      if (!currentUser.spiTokenExpiration && currentUser.metadata?.lastSignInTime) {
        const lastSignIn = new Date(currentUser.metadata.lastSignInTime).getTime();
        const elapsed = (Date.now() - lastSignIn) / (1000 * 60);
        if (elapsed >= warningMinutes && !warningShown.current) {
          toast.warning("Your session may expire soon. Save your work and refresh if needed.");
          warningShown.current = true;
        }
      }
    }, 60000);

    return () => clearInterval(checkInterval);
  }, [currentUser, warningMinutes, toast]);
}
